import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchDraftReport, patchReportSection, finalizeReport, saveDraftReport } from '../api/draftReport';

export const useDraftReport = (caseNumber, enabled = true) => {
  return useQuery({
    queryKey: ['draft-report', caseNumber],
    queryFn: () => fetchDraftReport(caseNumber),
    enabled: !!caseNumber && enabled,
    retry: false,
    staleTime: 30_000,
  });
};

export const usePatchReportSection = (caseNumber) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId, sectionKey, content }) =>
      patchReportSection(reportId, sectionKey, content),
    onSuccess: (data) => {
      qc.setQueryData(['draft-report', caseNumber], data);
    },
  });
};

export const useFinalizeReport = (caseNumber) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId, decision }) => finalizeReport(reportId, decision),
    onSuccess: (data) => {
      qc.setQueryData(['draft-report', caseNumber], data);
    },
  });
};

/**
 * Persist a freshly-generated agentic report as the case's latest draft.
 * On success the cached draft is replaced so the ReportEditor opens the new version.
 */
export const useSaveDraftReport = (caseNumber) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => saveDraftReport(caseNumber, payload),
    onSuccess: (data) => {
      qc.setQueryData(['draft-report', caseNumber], data);
    },
  });
};
